import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  max-height: 348px;
  overflow: scroll;
  margin-top: ${props => props.theme.spacing.sp8};
  overflow-x: hidden;
  overflow-y: auto;
`

export const CarbonOffsetContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`
